module.exports = __webpack_public_path__ + "static/img/frozen.20cb7801.png";